'use strict';

module.exports = ['$scope', '$state', function ($scope, $state) {

        $scope.onSelectCallBackFn = function (node) {
            console.log('master', node);                      
            $scope.nodeSelect({node: node});
        };


    }];





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/directives/situationRecordNavBar/navBarMasterCtrl.js
// module id = 264
// module chunks = 0